const exchange = {
  enabledWallets: 'Enabled wallets',
  exchange: 'Exchange',
  exchangeTxs: 'Exchange transactions',
};

export default exchange;
